<template>
  <div class="user-avatar" :style="avatarStyle">
    <img
      v-if="showImage"
      class="avatar-image"
      :src="avatar"
      :alt="displayName"
      :title="displayName"
      @error="handleImageError"
    />
    <span v-else class="avatar-fallback" :style="fallbackStyle">{{ initial }}</span>
  </div>
</template>

<script>
export default {
  name: "UserAvatar",
  props: {
    avatar: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    size: {
      type: Number,
      default: 40,
    },
    radius: {
      type: String,
      default: "50%",
    },
    fontSize: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loadError: false,
    };
  },
  computed: {
    showImage() {
      return !!this.avatar && !this.loadError;
    },
    displayName() {
      const val = String(this.name || "").trim();
      return val || "用户";
    },
    initial() {
      return this.displayName.charAt(0).toUpperCase();
    },
    avatarStyle() {
      const size = Number(this.size);
      const style = {
        borderRadius: this.radius || "50%",
      };
      if (size > 0) {
        style.width = `${size}px`;
        style.height = `${size}px`;
      }
      return style;
    },
    fallbackStyle() {
      const size = Number(this.size);
      const fallbackFont =
        Number(this.fontSize || 0) || (size > 0 ? Math.max(12, Math.floor(size * 0.4)) : 14);
      return {
        fontSize: `${fallbackFont}px`,
      };
    },
  },
  watch: {
    avatar() {
      this.loadError = false;
    },
  },
  methods: {
    handleImageError() {
      this.loadError = true;
    },
  },
};
</script>

<style scoped lang="scss">
.user-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: linear-gradient(135deg, #5a8fff, #8ab2ff);
  color: #fff;
  user-select: none;
}

.avatar-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.avatar-fallback {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  line-height: 1;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/common/UserAvatar.vue